import { useCurrentCampagne } from '@common/hooks/campagne';
import { useGetCampagneRncpsDistinctFieldQuery } from '@common/services';
import { RncpFilterField } from '@common/services/rncp';
import { SelectOption } from '@common/ui';
import { SetUtils } from '@common/utils';
import React from 'react';
import { DropdownSelectionFilter } from '../DropdownSelectionFilter';

export const TypeCertificationFilter = ({ type, onTypeChange }: TypeCertificationFilterProps) => {
  const { campagne } = useCurrentCampagne();

  const { data: filters = [] } = useGetCampagneRncpsDistinctFieldQuery({
    id: campagne?.id,
    field: RncpFilterField.TYPE_CERTIFICATION,
  }, {
    skip: !campagne,
    refetchOnMountOrArgChange: true,
  });

  const options: SelectOption[] = filters.map(type => ({ label: type, value: type }));

  return (
    <DropdownSelectionFilter selection={new Set((type) ? [type] : [])}
                             onSelectionChange={(selection) => onTypeChange(SetUtils.takeFirst(selection))}
                             buttonLabel="type de certification"
                             options={options}
                             tooltip="Filtrer par type de certification" />
  );
};

interface TypeCertificationFilterProps {
  type: string | null;
  onTypeChange: (type: string) => void;
}